import React from "react";
import { Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { CommonConstants } from "utils/constants";
import variables from "theme/styles/_variables.module.scss";
import { CSSHelper } from "utils/helpers";

export const DialogTransition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  const [delayedIn, setDelayedIn] = React.useState(false);
  const timer = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    if (props.in)
      timer.current = setTimeout(
        () => setDelayedIn(true),
        CSSHelper.convertMSToNumber(variables.cardNavigationTransitionDelay)
      );
    else {
      setDelayedIn(false);
      timer.current && clearTimeout(timer.current);
    }
    return () => {
      timer.current && clearTimeout(timer.current);
    };
  }, [props.in]);

  return (
    <Slide direction="up" ref={ref} {...props} in={delayedIn} timeout={CommonConstants.DialogTransitionDurationMs} />
  );
});
